// extracted by mini-css-extract-plugin
export var date = "post-card-module--date--3Ia-r";
export var intro = "post-card-module--intro--vaKqV";
export var pill = "post-card-module--pill--3CoQ0";
export var pills = "post-card-module--pills--2QVXq";
export var postCard = "post-card-module--postCard--NBQRH";
export var readMore = "post-card-module--readMore--3cAt6";
export var title = "post-card-module--title--wG5Ti";
export var titleLink = "post-card-module--titleLink--30b7D";